// TODO: Adjust times before release

export const IDLE_TIMEOUT = 1000 * 600
export const IDLE_PROMPT_TIMEOUT = 1000 * 5
export const CONFIRMATION_SUCCESS_TIMEOUT = 1000 * 500
export const CONFIRMATION_ERROR_TIMEOUT = 1000 * 10

export const LANGUAGES = [
  {
    code: 'en',
    label: 'English'
  },
  {
    code: 'pl',
    label: 'Polish'
  }
]
